export default __webpack_public_path__ + "static/media/event-bg.14b40d5a.png";